import _defineProperty from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import { isSSR } from "../plugins/Platform.js";
export default function cache(vm, key, obj) {
  if (isSSR === true) return obj;
  var k = "__qcache_".concat(key);
  return vm[k] === void 0 ? vm[k] = obj : vm[k];
}
export function cacheWithFn(vm, key, fn) {
  if (isSSR === true) return fn();
  var k = "__qcache_".concat(key);
  return vm[k] === void 0 ? vm[k] = fn() : vm[k];
}
export function getPropCacheMixin(propName, proxyPropName) {
  return {
    data: function data() {
      var target = {};
      var source = this[propName];

      for (var prop in source) {
        target[prop] = source[prop];
      }

      return _defineProperty({}, proxyPropName, target);
    },
    watch: _defineProperty({}, propName, function (newObj, oldObj) {
      var target = this[proxyPropName];

      if (oldObj !== void 0) {
        // we first delete obsolete events
        for (var prop in oldObj) {
          if (newObj[prop] === void 0) {
            this.$delete(target, prop);
          }
        }
      }

      for (var _prop in newObj) {
        // we then update changed events
        if (target[_prop] !== newObj[_prop]) {
          this.$set(target, _prop, newObj[_prop]);
        }
      }
    })
  };
}